import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatOrderCreatedDate = (dateString) => {
    //dayjs(dateString).format("MMM D, hh:mm A");
    //checks for valida js dates
    if(isNaN(new Date(dateString))){
        return "-";
    }

    return dayjs.utc(dateString).tz(dayjs.tz.guess()).format("MMM D, hh:mm A");
}

export const formatYYYY_MM_DD = (dateString) => {
    
    //checks for valida js dates
    if(isNaN(new Date(dateString))){
        return "-";
    }
    
    return dayjs.utc(dateString).tz(dayjs.tz.guess()).format("YYYY-MM-DD");
}

export const formatYYYY_MM_DD_HH_MM_A = (dateString) => {
    
    //checks for valida js dates
    if(isNaN(new Date(dateString))){
        return "-";
    }
    
    return dayjs.utc(dateString).tz(dayjs.tz.guess()).format("YYYY-MM-DD hh:mm A");
}

export const formatHH_MM_SS = (dateString) => {
    
    //checks for valida js dates
    if(isNaN(new Date(dateString))){
        return "-";
    }

    return dayjs.utc(dateString).tz(dayjs.tz.guess()).format("HH:mm A");
}

export const formatPaymentDate = (dateString) => {
    
    //checks for valida js dates.
    if(isNaN(new Date(dateString))){
        return "-";
    }

    return dayjs.utc(dateString).tz(dayjs.tz.guess()).format("MMMM D, YYYY, h:mm A");
};